import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ValidatorResult} from "@model";

@Component({
  selector: 'validation-modal',
  templateUrl: './validation-modal.component.html',
  styleUrls: ['./validation-modal.component.scss']
})
export class ValidationModalComponent {
  @Input() title: string | undefined;
  @Input() validatorResult: ValidatorResult | undefined;
  @Input() dismissButtonTitle: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() showConfirmButton: boolean = false;

  constructor(public activeModal: NgbActiveModal) {
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }

  onConfirmClick(): void {
    this.activeModal.close();
  }
}

